import React from 'react';
import _ from 'lodash';
import { render, ReactDOM, unmountComponentAtNode } from 'react-dom';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import configureStore, { hydrateState } from './redux/configureStore';
import Root from './App';
import KloudlessLayout from './kloudless/KloudlessLayout';

// from reports - old code
import './less/BootstrapCustom.less';
import './less/styles.less';

const elemForReact = window.document.getElementById('react-app');

if (elemForReact) {
  const preloadedState = {
    user: {
      settings: _.pick(
        window.Drupal.settings,
        'case_lookup_default_courts',
        'pacer_search_default_case_type',
        'currentUser',
        'firmMember',
        'firmMaster',
      ),
    },
    // todo leaving below for now, but remember to refactor this out of the components in the future
    immediateSearch: window.immediateSearchArgs || {},
  };

  const hydratedState = hydrateState(preloadedState);
  const store = configureStore(hydratedState);

  const renderDom = (Component) => {
    render(
      <AppContainer>
        <Provider store={store}>
          <Component />
        </Provider>
      </AppContainer>,
      elemForReact,
    );
  }

  renderDom(Root);

  if (module.hot) {
    module.hot.accept('./App', () => {
      console.info('!!!accepted hot reload!');
      const Next = require('./App').default;
      renderDom(Next);
    });
  }
}

// TODO: List of supported services should be hard-coded in the kloudlesslayout,
// it's not something that is "configurable"
const kloudlessServices = [
  'box', 'dropbox', 'gdrive', 'skydrive','onedrivebiz'
];

window.UI = {
  mountComponent: function(dest, sourceFile, props) {
    try {
      var context = require.context("./components/case", true, /\.js$/);

      console.log('mountComponent', sourceFile, 'into', dest);
      const c = context(sourceFile);
      const Component = c.default
      if (! Component ) throw `Unable to require('./components/case/${ sourceFile }')`;

      const store = configureStore();
      render(
        <AppContainer>
          <Provider store={store}>
            <Component {...props}/>
          </Provider>
        </AppContainer>,
        dest
      );

      module.hot && module.hot.accept(context.id, () => {
        var context = require.context("./components/case", true, /\.js$/);

        console.log(`Accepted hot reload for ${sourceFile}!`);
        const NextComponent = context(sourceFile).default;
        render(
          <AppContainer>
            <Provider store={store}>
              <NextComponent {...props}/>
            </Provider>
          </AppContainer>,
          dest
        )
      });
    }
    catch (e) {
      console.log('Unable to Mount Component', e);
    }
  },
  mountKloudless() {
    const store = configureStore();

    render(
      <AppContainer>
        <Provider store={store}>
          <KloudlessLayout svc={kloudlessServices} />
        </Provider>
      </AppContainer>,
      document.getElementById('kloudless-ctrl-root'),
    );

    if (module.hot) {
      module.hot.accept('./kloudless/KloudlessLayout', () => {
        console.log('accepted hot reload! kloudless');
        const NextLayout = require('./kloudless/KloudlessLayout').default;
        render(
          <AppContainer>
            <Provider store={store}>
              <NextLayout />
            </Provider>
          </AppContainer>,
          document.getElementById('kloudless-container'),
        );
      });
    }
  },

  automountReactComponents() {
    console.log('Looking for components to mount');
    var elements = document.querySelectorAll('.__react__component');
    for (var i = 0; i < elements.length; i++) {
      const elt = elements[i];
      console.log("About to mount react component on ", elt);
      var props = JSON.parse(elt.getAttribute('data-component-props'));
      mountReactComponent(elt, elt.getAttribute('data-component'), props);
    }
  },

};

// Automounting of components from the page that look like this:
// <div class="__react_component" data-component="path/to/Source.jsx" data-component-props="{PROPS}"></div>
// this is equivalent to mounting <Source ...PROPS />

function mountReactComponent(dest, sourceFile, props) {
  try {
    var context = require.context("./", true, /\.jsx$/);

    console.log('mountComponent', sourceFile, 'with props', props, 'into', dest);
    const Component = context(sourceFile).default;
    if (! Component ) throw `Unable to require('./${ sourceFile }')`;

    const store = configureStore();
    render(
      <AppContainer>
        <Provider store={store}>
          <Component {...props}/>
        </Provider>
      </AppContainer>,
      dest
    );

    module.hot && module.hot.accept(context.id, () => {
      var context = require.context("./", true, /\.jsx$/);

      console.log(`Accepted hot reload for ${sourceFile}!`);
      const NextComponent = context(sourceFile).default;
      render(
        <AppContainer>
          <Provider store={store}>
            <NextComponent {...props}/>
          </Provider>
        </AppContainer>,
        dest
      )
    });
  }
  catch (e) {
    console.log('Unable to Mount Component', e);
  }
}

UI.automountReactComponents();

// // leaving here for now
// if (window.location.href.indexOf('#tab-menu') !== -1 && window.Drupal.settings.has_dockets) {
//   const segments = window.location.href.split('/');
//   const case_uuid = segments[segments.length - 1].split('-')[0];
//   window.openTab('query-ajax', 'dockets', 'Docket', case_uuid, false, '#dockets');
// }



/** WEBPACK FOOTER **
 ** ./src/index.jsx
 **/